import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import 'component_ui/designer-profile-header';
import PriceCalculator from 'component_ui/price-calculator';
import ScrollToElement from 'component_ui/scroll-to-element';
import ServiceImageUploader from 'component_ui/service-image-uploader';
import SpanLink from 'component_ui/span-link';
import TagEditor from 'component_ui/tag-editor';
import ToggleVisible from 'component_ui/toggle-visible';
import FieldValidator from 'component_ui/field-validator';
import initIndicator from 'apps/online-status/initIndicator';

import initResponsivenessScore from 'apps/responsiveness-score/';
import ResponsivenessScoreContentListing from 'apps/responsiveness-score/components/responsiveness-score-content-listing';

const initOnlineStatus = () => {
    const lastSeenIndicator = document.querySelector('[data-last-seen-times-url]');
    if (lastSeenIndicator) {
        initIndicator(lastSeenIndicator);
    }
};

const responsivenessScoreNode = document.querySelector(
    '[data-responsiveness-score-origin=services]'
);

document.addEventListener('DOMContentLoaded', () => {
    initOnlineStatus();

    if (responsivenessScoreNode) {
        initResponsivenessScore(responsivenessScoreNode, ResponsivenessScoreContentListing);
    }

    const csrfParam = $('meta[name=csrf-param]').attr('content');
    const csrfToken = $('meta[name=csrf-token]').attr('content');

    ServiceImageUploader.attachTo('[data-page-wrapper]', {
        // ??
        csrfParam,
        csrfToken,
        s3BucketInputSelector: '[data-service-image-s3-bucket]',
        s3ObjectInputSelector: '[data-service-image-s3-object]',
    });

    PriceCalculator.attachTo('[data-price-calculator]');

    ScrollToElement.attachTo('[data-scroll-to-element]');

    SpanLink.attachTo('[data-span-link]');

    TagEditor.attachTo('[data-tag-editor-design-tags]', {
        allowCreateTag: false,
        dataSourceLocation: 'local',
        disallowDefault: true,
        caseSensitive: false,
    });

    ToggleVisible.attachTo('[data-toggle-visible]', {
        hideOnBodyClick: true,
    });

    FieldValidator.attachTo('[data-field-validator]');
});



// WEBPACK FOOTER //
// ./src/js/page/services-services.js